<template>
  <v-container>
      <v-row>
          <v-col>
              <h1 class="text-h2">Préscription</h1>
              <h2 id="global" class="text-h4">Principes de base</h2>
              <p>Une préscriptions représente une configuration de club personnalisé, il est possible de créer une préscription sans la transformer en commande</p>
          </v-col>
      </v-row>
      <v-row>
          <v-col>
              <h3 id="list" class="text-h4">Liste des préscriptions et status</h3>
              <p>Dans la liste des préscription vous pouvez voir toutes les préscriptions existantes, regroupé par status</p>
              <p>Définition des status :</p>
                <ul>
                    <li>
                        <strong>NEW</strong> : la préscription est créée mais n'a pas encore été transformée en commande
                    </li>
                    <li>
                        <strong>QUOTED</strong> : la préscription a été transformée en commande et est en cours de validation
                    </li>
                    <li>
                        <strong>READY TO BUILD</strong> : la préscription a été validée et est prête à être construite
                    </li>
                    <li>
                        <strong>BUILT</strong> : la préscription a été construite et est prête à être expédiée
                    </li>
                    <li>
                        <strong>SHIPPED</strong> : la préscription a été expédiée
                    </li>
                </ul>
          </v-col>
      </v-row>
      <v-row>
          <v-col>
              <h3 id="create" class="text-h4">Création de préscriptions</h3>
              <p>Cliquer sur le bouton "ADD PRESCRIPTION" situé en haut à droite du la liste des préscriptions.</p>
              <p>Pour créer une préscription il est important de saisir ces champs :</p>
                <ul>
                    <li>
                        <strong>SHOP</strong> : le shop au quel est rataché la préscription
                    </li>
                    <li>
                        <strong>LOCATIONS</strong> : le lieu de préparation de la préscription
                    </li>
                    <li>
                        <strong>SHIPPING</strong> : le type d'envoi prévu
                    </li>
                    <li>
                        <strong>CURRENCY</strong> : la monnaie de la préscription
                    </li>
                    <li>
                        <strong>TAX RATE</strong> : le taux de la TVA appliqué
                    </li>
                    <li>
                        <strong>CUSTOMER</strong> : le client
                    </li>
                    <li>
                        <strong>CLUB FITTER</strong> : le fitter qui a effectué la fitting
                    </li>
                    <li>
                        <strong>FITTING TYPE</strong> : le type de fitting facturé au client
                    </li>
                    <li>
                        <strong>FITTING DATE</strong> : la date du fitting
                    </li>
                </ul>
                <p>Lorsque la préscription est crée il est possible d'ajouter un ou plusieurs articles à la préscription.</p>
                <p>Pour chaque club ajouté vous pouvez définir les valeurs de fitting selon votre procédure de fitting.</p>
                <p>Vous pouvez dupliquer une préscription pour une nouvelle commande en cliquant sur le bout on "DUPLICATE".</p>
                <p>Vous pouvez imprimer la préscription en cliquant sur le bouton "PRINT".</p>
          </v-col>
      </v-row>
      <v-row>
          <v-col>
              <h3 id="quote" class="text-h4">Quotation</h3>
              <p>Afin de créer une commande à partir d'une préscription il faut ajouter les produits voulu à une Quotation</p>
              <p>Soit vous cliqué sur la case à cocher "Quote" située à gauche de chaque produits, soit vous cliqué sur le bouton "ADD ALL ITEM TO QUOTE" en haut à droite</p>
              <p>Lorsque que la quotation à été crée, une bouton "VIEW QUOTE" est apparu en haut à droite</p>
              <p>Tant que la commande n'a pas été validée il est possible de modifier les valeurs d'une préscriptions</p>
          </v-col>
      </v-row>
  </v-container>
</template>

<script>
export default {

}
</script>

<style>

</style>